export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  lathe: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  components: "https://images.unsplash.com/photo-1606337321936-02d1b1a4d5ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  milling: "https://images.pexels.com/photos/8865187/pexels-photo-8865187.jpeg?auto=compress&cs=tinysrgb&w=1600",
  metrology: "https://images.unsplash.com/photo-1585366958403-bacb4c36a1a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  industrialDark: "https://images.unsplash.com/photo-1633523316711-a969b8f47bdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  factory: "https://images.unsplash.com/photo-1720036237193-ea82bdac7be0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  solar: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facility: "https://images.unsplash.com/photo-1543304376-1ae7c2be5e59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  grinding: "/cobi-rettifica.jpg?v=2",
  // Immagini reali d'archivio Cobi Meccanica
  cobiMetrology: "/cobi-metrology.jpg",
  cobiGears: "/cobi-gears.jpg",
  cobi5axis: "/cobi-5axis.jpg",
  cobiTurning: "/cobi-turning.jpg",
  cobiMilling: "/cobi-milling.jpg",
};
